import React, { useEffect, useRef, Suspense } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import Sub from "layouts/Sub.jsx";
import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";
import cookie from "react-cookies";
import "assets/scss/paper-dashboard.scss?v=1.1.0";
// import "perfect-scrollbar/css/perfect-scrollbar.css";
import { Provider, useSelector } from "react-redux";
import { createStore } from "redux";
import reducer from "../src/reducer/index";
import { connect } from "react-redux";
import Loader from "react-loader";
import { setAlert, intStatus } from "action/index.js";
// import NotificationAlert from "react-notification-alert";
import { store, persistor } from "store/index";
// Eager: first-screen pages + layouts + per-render chrome (allowlist)
// Home is intentionally LAZY (not eager): it is by far the heaviest route and,
// when bundled into the entry chunk, its parse + giant synchronous render pushed
// time-to-first-paint past Prerender's render budget on CPU-constrained workers
// (empty #root cached for "/" only). Lazy-loading pulls its heavy deps
// (slick/swiper/libphonenumber/react-bootstrap) out of the entry so React boots
// and commits far sooner. Renders under the existing <Suspense> wrapping <Routes>.
const Home = React.lazy(() => import("./page/Home"));
import Login from "views/pages/Login";
import LoginWithCaptcha from "views/pages/LoginWithCaptcha";
import Dashboard from "views/DashboardNew";
import NepalBranch from "components/PopUps/NepalBranch";
import ChromePopUp from "components/PopUps/Chrome";
import LaLoader from "components/Loader/LaLoader.jsx";
import AppDownloadPopup from "components/Frontend/AppDownloadPopup";
import MobileAppBanner from "components/Dashboard/New/MobileAppBanner";
import YouTubeModal from "components/Notification/YoutubeModal";
import { SnackbarProvider, enqueueSnackbar, closeSnackbar } from "notistack";
// Eager: non-component imports (text-file routes, hooks, utils, libs)
import robot from "./components/robots.txt";
// import Sitemap1 from "./components/sitemap.xml";
import fb from "./components/googleaa7a8b2d6a176fd2.txt";
import { isMobile } from "react-device-detect";
import DownloadApp from "components/PopUps/DownloadApp";
import MobileDetect from "mobile-detect";
import { setLoader } from "action";
import { toast } from "react-toastify";
import ScrollToTop from "./hooks/scrollToTop.js";
import routes from "routes";
import useFirebaseNotification from "./hooks/useFirebaseNotification";
import { initGA, trackPageView ,initMetaPixel , initTikTok ,trackMetaPageView,trackTikTokPageView } from "util/analytics";
// import { captureTrackingData } from "util/utmTracking";
import "../public/css/new-app.css";
// Lazy: route-level code-splitting for marketing/portal pages
const Home1 = React.lazy(() => import("./page/pteportal/Home"));
const ContactPortal = React.lazy(() => import("./page/pteportal/Contact"));
const AboutPortal = React.lazy(() => import("./page/pteportal/About"));
const LoginPortal = React.lazy(() => import("./page/pteportal/auth/Login"));
const SignupPortal = React.lazy(() => import("./page/pteportal/auth/Register"));
const ForgotPortal = React.lazy(() => import("./page/pteportal/auth/Forgot"));
const VideoCourse = React.lazy(() => import("./page/VideoCourse"));
const VideoCourseR3 = React.lazy(() => import("./page/VideoCourseR3"));
const WhatWeOffer = React.lazy(() => import("./page/WhatWeOffer"));
const MockPlan = React.lazy(() => import("./page/MockPlan"));
const Contact = React.lazy(() => import("./page/Contact"));
const About = React.lazy(() => import("./page/About"));
const PayOnline = React.lazy(() => import("./page/PayOnline"));
const JoinUs = React.lazy(() => import("./page/JoinUs"));
const Branches = React.lazy(() => import("./page/Branches"));
const Franchise = React.lazy(() => import("./page/Franchise"));
// const NaatiAppLp = React.lazy(() => import("./page/NaatiAppLp"));
const NaatiAppNew = React.lazy(() => import("./page/NaatiAppNew"));
const PTEAppNew = React.lazy(() => import("./page/PTEAppNew"));
const FreeMockTest = React.lazy(() => import("./page/FreeMockTest"));
const Naati = React.lazy(() => import("./page/Naati"));
const Pte = React.lazy(() => import("./page/Pte"));
const ReadingPte = React.lazy(() => import("./page/ReadingPte"));
const WritingPte = React.lazy(() => import("./page/WritingPte"));
const SpeakingPte = React.lazy(() => import("./page/SpeakingPte"));
const ListeningPte = React.lazy(() => import("./page/ListeningPte"));
const PteOnlineClasses = React.lazy(() => import("./page/PteOnlineClasses"));
const PteMockTest = React.lazy(() => import("./page/PteMockTest"));
const PteStudyMaterial = React.lazy(() => import("./page/PteStudyMaterial"));
const Term = React.lazy(() => import("./page/Term"));
const Feedback = React.lazy(() => import("./page/Feedback"));
const DailyFeedback = React.lazy(() => import("./page/DailyFeedback"));
const Refund = React.lazy(() => import("./page/Refund"));
const VideoAll = React.lazy(() => import("./page/VideoAll"));
const TestimonialAll = React.lazy(() => import("./page/TestimonialAll"));
const ScoreCardAll = React.lazy(() => import("./page/ScoreCardAll"));
const PteOnlineCoaching = React.lazy(() => import("./page/PteOnlineCoaching"));
const NaatiOnlineCoaching = React.lazy(() => import("./page/NaatiOnlineCoaching"));
const PteCoachingSydney = React.lazy(() => import("./page/PteCoachingSydney"));
const IeltsOnlineCoaching = React.lazy(() => import("./page/IeltsOnlineCoaching"));
const IeltsCoachingParramatta = React.lazy(() => import("./page/IeltsCoachingParramatta"));
const IeltsCoachingSydney = React.lazy(() => import("./page/IeltsCoachingSydney"));
const NaatiCoachingSydney = React.lazy(() => import("./page/NaatiCoachingSydney"));
const Sitemap = React.lazy(() => import("./page/Sitemap"));
const NotFound = React.lazy(() => import("./page/NotFound"));
const ThankYou = React.lazy(() => import("./page/ThankYou"));
const ThankYouPayout = React.lazy(() => import("./page/ThankYouPayout"));
const ThankYouRegister = React.lazy(() => import("./page/ThankYouRegister"));
const Maintenance = React.lazy(() => import("./page/Maintenance"));
const PteCore = React.lazy(() => import("./page/PteCore"));
const LeadThanks = React.lazy(() => import("components/ThankYou/ThankYou"));
const PrivacyPolicy = React.lazy(() => import("page/PrivacyPolicy"));
const Inst = React.lazy(() => import("page/Inst"));
const BusinessPage = React.lazy(() => import("page/BusinessPage"));
const RedirectToHome = React.lazy(() => import("./page/RedirectToHome"));
const Subscription = React.lazy(() => import("page/Payment"));
const MagicTokenLogin = React.lazy(() => import("page/MagicTokenLogin"));
const SubSuccess = React.lazy(() => import("page/SubSuccess"));
const SalesPage = React.lazy(() => import("page/SalesPage"));
const AppDownloadRedirect = React.lazy(() => import("./page/AppDownloadRedirect"));
const InvalidRegion = React.lazy(() => import("./page/InvalidRegion"));
const SuccessCard = React.lazy(() => import("components/Payments/SuccessCard"));
const InvalidRegionAccess = React.lazy(() => import("page/InvalidRegionAccess"));

const hist = createBrowserHistory();

const mapStateToProps = (state) => {
  // console.log("The state : ",!!state.token,!!state.user);
  return {
    token: state.token,
    loaded: state.loaded,
    user: state.user,
    subscribed: state.subscribed,
    alert: state.alert,
  };
};

import { cleanupAllTours } from "components/WebsiteTour/tourData";
import { initGTM } from "util/GTMHandler";
import PteScoreAcademic from "components/Frontend/PteScoreAcademic";
import PteScoreCore from "components/Frontend/PteScoreCore";
import PayOnlineCard from "page/PayOnlineCard";

// Lazy: city pages
const Victoria = React.lazy(() => import("components/Frontend/CityPages/Victoria"));
const Melbourne = React.lazy(() => import("components/Frontend/CityPages/Melbourne"));
const Queensland = React.lazy(() => import("components/Frontend/CityPages/Queensland"));
const Adelaide = React.lazy(() => import("components/Frontend/CityPages/Adelaide"));
const Perth = React.lazy(() => import("components/Frontend/CityPages/Perth"));
const NSW = React.lazy(() => import("components/Frontend/CityPages/NSW"));

// Lazy: SEO / misc frontend pages
const FameWallPte = React.lazy(() => import("components/Frontend/FameWallPte"));
const PteScoreSeo = React.lazy(() => import("components/Frontend/PteScoreSeo"));
const AIScoreSeo = React.lazy(() => import("components/Frontend/AIScoreSeo"));
const ExamVoucher = React.lazy(() => import("components/Frontend/ExamVoucher"));

// Marker attribute set on #root once the matched public route's OWN content has
// committed. The Prerender readiness poller (in ReactRouteAll) watches this instead
// of #root.childElementCount, which was too broad — global chrome (MobileAppBanner,
// SnackbarProvider, NepalBranch, YouTubeModal, popups) puts children in #root before
// the actual page renders, so childCount > 0 could flip prerenderReady on an
// incomplete page. This attribute is only set by the route's own lifecycle.
const PRERENDER_READY_ATTR = "data-route-content-ready";

// Diagnostic error boundary. A render-time throw anywhere in a route subtree
// normally unmounts the whole React tree, leaving an empty #root — which is
// exactly the empty snapshot Prerender captures for the Home route while it
// renders fine in every normal browser. This boundary catches such a throw and
// renders the error text INTO the DOM, so the failure becomes visible in
// Prerender's HTML snapshot (readable via curl) instead of being invisible.
// It also guarantees #root has children, so the prerenderReady content-signal
// can still fire. Kept lightweight and safe to leave in production.
class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    // Keep the Prerender readiness signal working even on a route error, so the
    // error snapshot is captured promptly instead of waiting for the cap.
    const root = document.getElementById("root");
    if (root) root.setAttribute(PRERENDER_READY_ATTR, "true");
    // eslint-disable-next-line no-console
    console.error("RouteErrorBoundary caught:", error, info);
  }
  render() {
    if (this.state.error) {
      const e = this.state.error;
      return (
        <div
          data-route-error="true"
          data-route={this.props.routeName || ""}
          style={{ padding: 16, fontFamily: "monospace", whiteSpace: "pre-wrap" }}
        >
          <h1>Route render error{this.props.routeName ? ` @ ${this.props.routeName}` : ""}</h1>
          <p data-error-name>{String(e && e.name)}</p>
          <p data-error-message>{String(e && e.message)}</p>
          <pre data-error-stack>{String((e && e.stack) || "").slice(0, 2000)}</pre>
          <pre data-error-componentstack>
            {String((this.state.info && this.state.info.componentStack) || "").slice(0, 2000)}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

// Wraps a matched public route's element. Its effect runs only AFTER that route's
// DOM has committed (a wrapper's effect fires after its children mount), so it marks
// "real page content is on screen" — not merely "something rendered into #root".
const RouteContentMarker = ({ children }) => {
  useEffect(() => {
    const root = document.getElementById("root");
    if (root) root.setAttribute(PRERENDER_READY_ATTR, "true");
    return () => {
      const root = document.getElementById("root");
      if (root) root.removeAttribute(PRERENDER_READY_ATTR);
    };
  }, []);
  return children;
};

const markReady = (element) => <RouteContentMarker>{element}</RouteContentMarker>;

const ReactRouteAll = ({ token, loaded, user, subscribed, alert }) => {
  const location = useLocation();
  const prevLocation = useRef(location.pathname);
  const snackbarRef = useRef(null);
  const intStatuscheck = useSelector((state) => state.intStatus);
  const { fcmToken, notification, youtubeModal, setYoutubeModal } = useFirebaseNotification();
  // console.log("The intstatuscheck : ",intStatuscheck);
  // const analyticsInitializedRef = useRef(false);
  // Cleanup tours and handle GTM persistence on route change

  useEffect(() => {
    // if (analyticsInitializedRef.current) return;
    
    // const isPublic = !location.pathname.startsWith('/admin') && !location.pathname.startsWith('/auth');
    
    // Only initialize analytics on public routes
    // if (isPublic) {
      initGA();
      initMetaPixel('197333187452630');
      initTikTok('CG0870RC77U8JD8FUT4G');
      // analyticsInitializedRef.current = true;
      console.log('Analytics initialized for public route');
    // }
  }, []);

  // Prerender.io readiness signal.
  // index.html sets window.prerenderReady = false up-front so the Prerender bot
  // waits for our explicit signal instead of guessing via network-idle. Mark ready
  // once the matched ROUTE'S OWN content has committed — detected via the
  // PRERENDER_READY_ATTR marker set by <RouteContentMarker> (and by the error
  // boundary). We deliberately do NOT use #root.childElementCount: global chrome
  // (banners, snackbars, modals, popups) lands children in #root before the page
  // renders, so childCount > 0 could flip the signal on an incomplete page.
  //
  // Two things we must NOT do, learned the hard way on the heavy Home route
  // (7.4 MB bundle, ~149 images), which takes many seconds to first paint inside
  // Prerender's constrained headless Chrome:
  //   1. Do NOT gate on document.readyState === "complete" — with that many images
  //      a heavy page can sit at "interactive" indefinitely, so the content signal
  //      never fires and we fall through to the cap.
  //   2. Do NOT use a short cap. A premature cap flips prerenderReady=true before
  //      the page has rendered, so the bot snapshots the empty shell — and a cap
  //      shorter than Prerender's own page timeout actively WASTES that budget.
  //      Prerender is configured with a 60s render timeout, so the cap sits just
  //      under that 60s ceiling and only matters as a last-resort fallback for a
  //      genuinely broken route. Real users never hit the cap.
  // Poll with setInterval (NOT requestAnimationFrame — rAF is throttled/suspended in
  // headless/background tabs and may never fire under Prerender). Reset on every
  // navigation so client-side route changes are handled the same way.
  useEffect(() => {
    window.prerenderReady = false;
    // NOTE: do NOT remove PRERENDER_READY_ATTR here. On initial mount React fires
    // child effects (RouteContentMarker, which SETS the attr) BEFORE this parent
    // effect, so clearing it here would clobber the just-set marker and the content
    // signal would never fire (only the 55s cap would). The marker owns the
    // attribute's full lifecycle — its cleanup clears it on unmount/navigation, and
    // window.prerenderReady=false above is the per-navigation reset.
    let done = false;
    const READY_CAP_MS = 55000; // just under Prerender's 60s page timeout; content signal normally wins first
    const POLL_MS = 100;

    const contentIsReady = () => {
      const el = document.getElementById("root");
      return !!el && el.getAttribute(PRERENDER_READY_ATTR) === "true";
    };

    const finish = (fromCap) => {
      if (done) return;
      // CRITICAL: the cap must NEVER declare readiness on an empty #root.
      // On Prerender's CPU-constrained workers the heavy Home route's first
      // paint can cross READY_CAP_MS; if the cap then flipped prerenderReady=true
      // unconditionally, Prerender would snapshot the still-empty shell and cache
      // a blank page (the exact Home-only failure we diagnosed). So when the cap
      // fires before content has committed, do nothing and let the poller keep
      // waiting — Prerender then uses its full page-timeout budget (and won't
      // cache a false "successful" empty render) instead of capturing blank.
      if (fromCap && !contentIsReady()) return;
      done = true;
      clearInterval(intervalId);
      clearTimeout(capId);
      window.prerenderReady = true;
    };

    const intervalId = setInterval(() => {
      if (contentIsReady()) finish(false);
    }, POLL_MS);
    const capId = setTimeout(() => finish(true), READY_CAP_MS);

    return () => {
      done = true;
      clearInterval(intervalId);
      clearTimeout(capId);
    };
  }, [location.pathname, location.search]);

  useEffect(() => {
    
    // const wasPublic = prevLocation.current && !prevLocation.current.startsWith("/admin") && !prevLocation.current.startsWith("/auth");
    // const isProtected = location.pathname.startsWith("/admin") || location.pathname.startsWith("/auth");
    // If moving from public to protected, force a refresh to clear trackers
    // if (wasPublic && isProtected && prevLocation.current !== location.pathname) {
    //   prevLocation.current = location.pathname;
    //   window.location.reload();
    //   return;
    // }
    if (prevLocation.current !== location.pathname) {
      cleanupAllTours();
      prevLocation.current = location.pathname;
    }
 
    // GTM is now loaded directly in index.html with route protection
    // No need to call initGTM here anymore
    
    // Track page views only on public routes
    // if (!location.pathname.startsWith('/admin') && !location.pathname.startsWith('/auth')) {
      trackPageView(location.pathname + location.search);
      trackMetaPageView();
      trackTikTokPageView();
       if (window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search,
    });
  }
  // }

  }, [location.pathname , location.search]);

  useEffect(() => {
    if (fcmToken) {
      // console.log('FCM Token:', fcmToken);
    }
  }, [fcmToken]);

  useEffect(() => {
    if (notification) {
      // console.log('New notification:', notification);
    }
  }, [notification]);

  // const notificationAlertRef = useRef(null);
  const isPortalUrl = (pathname) => {
    if (!pathname || typeof pathname !== "string") return; // safeguard
    const starts_with = pathname.indexOf("/admin/");
    if (starts_with === 0) {
      document.querySelector("html").classList.add("student-portal");
    } else {
      document.querySelector("html").classList.remove("student-portal");
    }
  };

  const isDashboard = (pathname) => {
    if (!pathname || typeof pathname !== "string") return;
    const starts_with = pathname.indexOf("/admin/dashboard");
    if (starts_with === 0) {
      document.querySelector("html").classList.add("student-dashboard");
    } else {
      document.querySelector("html").classList.remove("student-dashboard");
    }
  };

  // const notify = (type, message) => {
  //   switch (type) {
  //     case 1:
  //       type = "success";
  //       break;
  //     case 2:
  //       type = "danger";
  //       break;
  //     default:
  //       break;
  //   }
  //   const options = {
  //     place: "tr",
  //     message: (
  //       <div>
  //         <div>{message}</div>
  //       </div>
  //     ),
  //     type: type,
  //     icon: "now-ui-icons ui-1_bell-53",
  //     autoDismiss: 7,
  //   };
  //   // if (notificationAlertRef.current) {
  //   //   notificationAlertRef.current.notificationAlert(options);
  //   // }
  // };

  const notify = (type, message) => {
    const options = {
      position: "top-right",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    };

    switch (type) {
      case 1:
        toast.success(message, options);
        break;
      case 2:
        toast.error(message, options);
        break;
      default:
        toast.info(message, options);
        break;
    }
  };

  // useEffect(() => {
  //   store.dispatch(setLoader(true));
  //   store.dispatch(intStatus(true));
  //   if (loaded) {
  //     window.addEventListener("load", () => {
  //       let snackbarId;
  //       window.addEventListener("online", () => {
  //         closeSnackbar(snackbarId);
  //         store.dispatch(intStatus(true));
  //         document.getElementById("internet-down").remove();
  //       });

  //       window.addEventListener("offline", () => {
  //         snackbarId = enqueueSnackbar("No internet connection", {
  //           variant: "error",
  //           persist: true,
  //         });
  //         store.dispatch(intStatus(false));
  //         const div = document.createElement("div");
  //         div.className = "modal-backdrop fade show";
  //         div.id = "internet-down";
  //         if (document.getElementsByClassName("wrapper").length > 0) {
  //           document.getElementsByClassName("wrapper")[0].appendChild(div);
  //         } else if (
  //           document.getElementsByClassName("dashboardPage").length > 0
  //         ) {
  //           document
  //             .getElementsByClassName("dashboardPage")[0]
  //             .appendChild(div);
  //         } else {
  //           document.getElementById("root").appendChild(div);
  //         }
  //       });
  //     });
  //   }

  //   setTimeout(() => {
  //     isPortalUrl(hist.location.pathname);
  //     isDashboard(hist.location.pathname);
  //   }, 500);

  //   const unlisten = hist.listen((location) => {
  //     isPortalUrl(location.pathname);
  //     isDashboard(location.pathname);
  //   });

  //   return () => {
  //     unlisten();
  //   };
  // }, [loaded]);

 useEffect(() => {
  if (!loaded) return;

  store.dispatch(setLoader(true));
  store.dispatch(intStatus(navigator.onLine));

  const handleOnline = () => {
    if (snackbarRef.current) {
      closeSnackbar(snackbarRef.current);
      snackbarRef.current = null;
    }

    store.dispatch(intStatus(true));

    const el = document.getElementById("internet-down");
    if (el) el.remove();
  };

 const handleOffline = () => {
  if (snackbarRef.current) return;

  snackbarRef.current = "pending"; // <-- block duplicates immediately

  snackbarRef.current = enqueueSnackbar("No internet connection", {
    variant: "error",
    persist: true,
  });

  store.dispatch(intStatus(false));

  if (!document.getElementById("internet-down")) {
    const div = document.createElement("div");
    div.className = "modal-backdrop fade show";
    div.id = "internet-down";

    const parent =
      document.querySelector(".wrapper") ||
      document.querySelector(".dashboardPage") ||
      document.getElementById("root");

    parent.appendChild(div);
  }
};

  window.addEventListener("online", handleOnline);
  window.addEventListener("offline", handleOffline);

  return () => {
    window.removeEventListener("online", handleOnline);
    window.removeEventListener("offline", handleOffline);
  };
}, [loaded]);

  useEffect(() => {
    if (location?.pathname) {
      isPortalUrl(location.pathname);
      isDashboard(location.pathname);
    }
  }, [location?.pathname]);

  useEffect(() => {
    if (alert.flag) {
      notify(alert.type, alert.message);
      store.dispatch(setAlert({ flag: false }));
    }
  }, [alert]);

  useEffect(() => {}, [token]);

  // respond.io chat widget: hide on internal (/admin) routes during SPA navigation.
  // The growth-tool injects <respond-io-widget> as a sibling of <body> (not inside
  // #root), so we must remove that custom element — removing only the script tag
  // leaves the launcher visible until a full reload.
  useEffect(() => {
    const WIDGET_ID = "respondio__growth_tool";
    const WIDGET_SRC =
      "https://cdn.respond.io/widget/widget.js?wId=cbb5ce71-52bf-42ba-9631-c3f70adb0a1b";
    const path = location.pathname;
    const isInternal =
      path === "/admin" ||
      path.startsWith("/admin/") ||
      path === "/sub" ||
      path.startsWith("/sub/");

    const removeWidget = () => {
      document.getElementById(WIDGET_ID)?.remove();
      document
        .querySelectorAll(
          'respond-io-widget, [id^="respondio"], iframe[title="Webchat Widget"], iframe[src*="respond.io"]'
        )
        .forEach((el) => el.remove());
      document.body?.classList.remove("respondio-active");
    };

    if (isInternal) {
      removeWidget();
    } else if (!document.getElementById(WIDGET_ID)) {
      const s = document.createElement("script");
      s.id = WIDGET_ID;
      s.src = WIDGET_SRC;
      document.body.appendChild(s);
    }
  }, [location.pathname]);

  const portal = [
    { path: "/", component: Home1 },
    { path: "/contact", component: ContactPortal },
    { path: "/about", component: AboutPortal },
  ];
  const portalAuth = [
    { path: "/auth/login", component: LoginPortal },
    { path: "/auth/register", component: SignupPortal },
    { path: "/auth/forgot", component: ForgotPortal },
  ];
  const subAuth = [{ path: "/auth/login", component: LoginPortal }];

  let videoCourseComponent;
  let freeMockTestComponent;
  if (import.meta.env.VITE_SHOW_PAGES === "0") {
    videoCourseComponent = RedirectToHome;
    freeMockTestComponent = RedirectToHome;
  } else {
    videoCourseComponent = RedirectToHome; // this is temp. redirection.
    freeMockTestComponent = RedirectToHome; // this will redirect to mock-test page.
  }

  const front = [
    { path: "/", component: Home },
    { path: "/robots.txt", component: robot },
    { path: "/googleaa7a8b2d6a176fd2.html", component: fb },
    { path: "/video-courses", component: VideoCourse },
    { path: "/video-courses-r3", component: VideoCourseR3 },
    { path: "/ai-in-education", component: WhatWeOffer },
    { path: "/about", component: About },
    { path: "/maintenance", component: Maintenance },
    { path: "/pay-online", component: PayOnline },
    { path: "/pay-online-old", component: PayOnlineCard },
    { path: "/join-us", component: JoinUs },
    { path: "/branches", component: Branches },
    { path: "/franchise", component: Franchise },
    // { path: "/naati-app-lp", component: NaatiAppLp },
    { path: "/naati-app", component: NaatiAppNew },
    { path: "/pte-app", component: PTEAppNew },
    { path: "/mock-test", component: FreeMockTest },
    { path: "/exam-voucher", component: ExamVoucher },
    { path: "/free-mock-test", component: freeMockTestComponent },
    { path: "/mock-feedback/:id", component: Feedback },
    { path: "/daily-feedback", component: DailyFeedback },
    { path: "/contact", component: Contact },
    { path: "/pte-coaching-classes-parramatta", component: Pte },
    { path: "/naati-coaching-classes-parramatta", component: Naati },
    { path: "/pte-reading-test-practice-material", component: ReadingPte },
    { path: "/pte-speaking-test-practice-material", component: SpeakingPte },
    { path: "/pte-writing-test-practice-material", component: WritingPte },
    { path: "/pte-listening-test-practice-material", component: ListeningPte },
    { path: "/pte-online-classes", component: PteOnlineClasses },
    { path: "/pte-mock-test", component: PteMockTest },
    { path: "/pte-study-material", component: PteStudyMaterial },
    { path: "/term", component: Term },
    { path: "/privacy-policy", component: PrivacyPolicy },
    { path: "/video-all", component: VideoAll },
    { path: "/testimonial-all", component: TestimonialAll },
    { path: "/refund-policies", component: Refund },
    { path: "/scorecard", component: ScoreCardAll },
    { path: "/sitemap", component: Sitemap },
    // { path: "/sitemap.xml", component: Sitemap1 },
    { path: "/pte-online-coaching", component: PteOnlineCoaching },
    { path: "/naati-ccl-online-coaching", component: NaatiOnlineCoaching },
    { path: "/pte-coaching-sydney", component: PteCoachingSydney },
    { path: "/ielts-online-coaching", component: IeltsOnlineCoaching },
    { path: "/ielts-coaching-parramatta", component: IeltsCoachingParramatta },
    { path: "/ielts-coaching-sydney", component: IeltsCoachingSydney },
    { path: "/naati-ccl-coaching-sydney", component: NaatiCoachingSydney },
    { path: "/thank-you", component: ThankYou },
    { path: "/trial-class-thankyou", component: LeadThanks },
    { path: "/thank-you-payout", component: ThankYouPayout },
    { path: "/register-success", component: ThankYouRegister },
    { path: "/pte-core", component: PteCore },
    { path: "/wall-of-fame", component: FameWallPte },
    { path: "/pte-score-calculator", component: PteScoreSeo },
    { path: "/pte-ai-scoring", component:AIScoreSeo},
    { path: "/inst", component: Inst },
    { path: "/business", component: BusinessPage },
    { path: "/user-login", component: MagicTokenLogin },
    { path: "/pay-success", component: SuccessCard },
    { path: "/sales", component: SalesPage },
    // { path: "/invalid/region", component: InvalidRegion },
    { path: "/invalid/region", component: InvalidRegionAccess },
    { path: "/download-app", component: AppDownloadRedirect },
    { path: "/city/victoria", component: Victoria },
    { path: "/city/melbourne", component: Melbourne },
    { path: "/city/queensland", component: Queensland },
    { path: "/city/adelaide", component: Adelaide },
    { path: "/city/greaterperth", component: Perth },
    { path: "/city/newsouthwales", component: NSW },
    { path: "/pte-score-calculator/academic", component: PteScoreAcademic },
    { path: "/pte-score-calculator/core", component: PteScoreCore },
  ];

  const isMainSite = window.location.hostname.split(".").shift() === "www";

  const getAdminRoutes = (routeList = routes) => {
    const result = [];

    routeList.forEach((route) => {
      if (route.collapse && route.views) {
        result.push(...getAdminRoutes(route.views));
      } else if (route.layout === "/admin" && route.path) {
        const childPath = route.path.startsWith("/")
          ? route.path.slice(1)
          : route.path;

        const Component = route.component;

        result.push(
          <Route key={childPath} path={childPath} element={<Component />} />
        );
      }
    });

    return result;
  };

  const getAuthRoutes = (routeList = routes) => {
    const result = [];

    routeList.forEach((route) => {
      if (route.collapse && route.views) {
        // recursively check nested routes
        result.push(...getAuthRoutes(route.views));
      } else if (route.layout === "/auth" && route.path) {
        const childPath = route.path.startsWith("/")
          ? route.path.slice(1)
          : route.path;

        const Component = route.component;

        result.push(
          <Route key={childPath} path={childPath} element={<Component />} />
        );
      }
    });

    return result;
  };

  const bannerExcludedPaths = [
    "/admin/mock",
    "/admin/extensive/new-sectional-tests",
    "/admin/fulltest",
    "/admin/sectionalTest",
    "/admin/test"
  ];

  return (
    <React.Fragment>
      <YouTubeModal
        isOpen={youtubeModal.isOpen}
        toggle={() => setYoutubeModal({ isOpen: false, url: '', title: '' })}
        videoUrl={youtubeModal.url}
        title={youtubeModal.title}
      />
      {!bannerExcludedPaths.some(path => location.pathname.includes(path)) && <MobileAppBanner />}
      {/* {isMobile && <DownloadApp os="test" />} */}
      {/* <LaLoader show={loaded} /> */}
      <SnackbarProvider maxSnack={2} />
      <NepalBranch />
      {/* <NotificationAlert ref={notificationAlertRef} /> */}
      {/* {!store.getState().is_portal && store.getState().is_main && (
        <ScrollToTop>
          <Routes>
            {front.length > 0 &&
              front.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={markReady(<props.component />)}
                  exact
                />
              ))}
            <Route path="/auth/*" element={<AuthLayout />}>
              <Route path="login" element={<Login />} />
              {getAuthRoutes()}
            </Route>

            {token != null && (
              <Route path="/admin/*" element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                {getAdminRoutes()}
              </Route>
            )}
            {token != null && (
              <Route path="/sub/subscription" element={<Sub />} />
            )}
            {token != null && (
              <Route path="/admin/sub/payment/form" element={<AdminLayout />} />
            )}
            {token != null && (
              <Route path="/admin/sub/success" element={<AdminLayout />} />
            )}
            {token === null && (
              <Route
                path="/auth/login/session-expired"
                element={<Navigate to="/auth/login/session-expired" replace />}
              />
            )}
            <Route path="*" element={markReady(<NotFound />)} exact />
          </Routes>
          <ChromePopUp />
          {isMobile && <DownloadApp os="test" />}
        </ScrollToTop>
      )} */}
      {!store.getState().is_portal && store.getState().is_main && (
        <ScrollToTop>
          <Suspense fallback={<LaLoader show={true} />}>
          <Routes>
            {front.length > 0 &&
              front.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={
                    <RouteErrorBoundary routeName={props.path}>
                      <RouteContentMarker>
                        <props.component />
                      </RouteContentMarker>
                    </RouteErrorBoundary>
                  }
                  exact
                />
              ))}

            {/* Auth routes */}
            <Route path="/auth/*" element={markReady(<AuthLayout />)}>
              <Route path="login" element={<LoginWithCaptcha />} />
              {getAuthRoutes()}
            </Route>

            {/* Protected Admin Routes */}
            <Route
              path="/admin/*"
              element={
                token ? <AdminLayout /> : <Navigate to="/auth/login" replace />
              }
            >
              {token && (
                <>
                  <Route index element={<Navigate to="dashboard" replace />} />
                  {getAdminRoutes()}
                </>
              )}
            </Route>

            {/* Other protected routes */}
            <Route
              path="/sub/subscription"
              element={token ? <Sub /> : <Navigate to="/auth/login" replace />}
            />
            {/* <Route
              path="/admin/sub/payment/form"
              element={token ? <AdminLayout /> : <Navigate to="/auth/login" replace />}
            />
            <Route
              path="/admin/sub/success"
              element={token ? <AdminLayout /> : <Navigate to="/auth/login" replace />}
            /> */}
            {token === null && (
              <Route
                path="/auth/login/session-expired"
                element={<Navigate to="/auth/login" replace />}
              />
            )}

            <Route path="*" element={markReady(<NotFound />)} exact />
          </Routes>
          </Suspense>

          <ChromePopUp />
          {!location.pathname.startsWith("/admin") && !location.pathname.startsWith("/sub") && <AppDownloadPopup />}
          {/* {isMobile && <DownloadApp os="test" />} */}
        </ScrollToTop>
      )}

      {store.getState().is_portal && store.getState().is_main && (
        <ScrollToTop>
          <Suspense fallback={<LaLoader show={true} />}>
          <Routes>
            {portal.length > 0 &&
              portal.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={markReady(<props.component />)}
                  exact
                />
              ))}
            {portalAuth.length > 0 &&
              portalAuth.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={markReady(<props.component />)}
                  exact
                />
              ))}
            {token != null && <Route path="/admin" element={<AdminLayout />} />}
            {token != null && (
              <Route path="/sub/subscription" element={<Sub />} />
            )}
            {token != null && (
              <Route path="/sub/payment/form" element={<Sub />} />
            )}
            {token != null && <Route path="/sub/success" element={<Sub />} />}

            {token != null && (
              <Route
                path="/admin/dashboard"
                element={<Navigate to="/admin/dashboard" replace />}
              />
            )}
            {token === null && (
              <Route
                path="/auth/login"
                element={<Navigate to="/auth/login" replace />}
              />
            )}
            <Route path="*" element={markReady(<NotFound />)} exact />
          </Routes>
          </Suspense>
          <ChromePopUp />
          {/* {isMobile && <DownloadApp os="test" />} */}
        </ScrollToTop>
      )}
      {!store.getState().is_main && (
        <ScrollToTop>
          <Suspense fallback={<LaLoader show={true} />}>
          <Routes>
            {subAuth.length > 0 &&
              subAuth.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={markReady(<props.component />)}
                  exact
                />
              ))}
            {token != null && <Route path="/admin" element={<AdminLayout />} />}
            {token != null && (
              <Route path="/sub/subscription" element={<Sub />} />
            )}
            {token != null && (
              <Route path="/sub/payment/form" element={<Sub />} />
            )}
            {token != null && <Route path="/sub/success" element={<Sub />} />}
            {token != null && (
              <Route
                path="/admin/dashboard"
                element={<Navigate to="/admin/dashboard" replace />}
              />
            )}
            {token === null && (
              <Route
                path="/auth/login"
                element={<Navigate to="/auth/login" replace />}
              />
            )}
            <Route path="*" element={markReady(<NotFound />)} exact />
          </Routes>
          </Suspense>
          <ChromePopUp />
          {/* {isMobile && <DownloadApp os="test" />} */}
        </ScrollToTop>
      )}

    </React.Fragment>
  );
};

export default connect(mapStateToProps, null)(ReactRouteAll);
